function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 28,
  height: 28,
  fill: "url(#pattern0_8_13)"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
  id: "pattern0_8_13",
  patternContentUnits: "objectBoundingBox",
  width: 1,
  height: 1
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#image0_8_13",
  transform: "scale(0.0104167)"
})), /*#__PURE__*/React.createElement("image", {
  id: "image0_8_13",
  width: 96,
  height: 96,
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAESklEQVR4nO2cTagWVRjHH8mCComiMjQLoja1KDBooatu7V20CKIo7GMZBBUE0W0rlqYb3dmqRYs+lDa2EA0UN6GW1u2DLPDFrl1n/v85Y1fNI8f7ChfJ67zzdc6c8/zggcvlvuc+8/vPO3PemTOviKIoiqIoiqIoyoAoiuI+AK+T/JrkcZIZgBLASZL7SE4bY9ZWHc8Y8yTJD91r3RhuLDfmeOyvALxGcqWkDsl7AWwHME/SVqiDJJ9ZYrxnSR6qMpb7nwA+AXCPpAgXZM1VFH+tvE+ttbdeHcv97H5XZyyS/5CckpQAsBHAhZrCroZw2BizypX7ueFYF/I8f0VS2fPRUP6iOj6uxmONe5qK/pjPmoednuoMgLslVgBsD0Dyjd4JWyXiqeb8AAKYj3KKCuAN33InCOFViQ0ufMiyA6kvJTZI/hSA2Kr1o8QGyTwAsVXrrMQGSQQgtmpBYgPA0QDEVioARyQ2SO70LXaC2iGxQXIqALFV62mJDWvtTSRnApB7o5pxvUqM5Hn+cgCCl6yiKF6SWLHWLgfwg2/J1ysAx1yPEjMA1gO4FKD8SwDWSQqQ3OFbeBIzn+sxGo1ub+tGSks1Mzs7u0JSoiiKJwD861s+gHNFUTwuKVIUxYsBBLBRUgbAVo/yt0jqWGuXk9ztIYDd0U85q+LW9ZDc36P8g24iULnBFJibm7sDwPc9HHaOZVl2p+/tDRJjzCqSv3co/8+yLNf43s6gyfP8EQCnOpB/yo3te/uGFMJfLcofAXjU93YNirIsHyT5WwvyT2ZZ9rDv7RkkZVk+QPKXBvL/yLLsId/bMWiMMfeTPFEjgBPutb77j4Isy+4i+d0Ee/7hZB+86Apr7W0k91SQvze5K5t9Ya29GcCuJeTvcn/TW0OpQvJNAP8tEu/usE1ba5f57i0ZADwHwIzvKbzgu58kyfP8KVe++1Aa4kIk+TnJvwGcJ/krgM1RPqgRGgDeWXw+ueakflrfYR3iTtwVprWn3cOFXfaRJKwgf1FtklCvWpJ8i+QX4ydgzrZ5CXmp6lG+q58lFNxcG8CGSS4NMKAAasi/snRFQoDkYyQP+BTPBgHUkT8OYCQhrGwef+2LHWIArCl/HMBn4hMA7/kWzgbPcDWUf3GS7ypqnSbNs8OVDX31n+f5290a7rB5dhfAR330D+CD7i0PT/5FNxnoof/pfkx307ztMIBtPfSv8vn/8r+11t6i8j0cdgBsU/n9iqeb7QD4WI/57YrdY4xZHdg5K51jvml5rY7K9xgAdc+vdUL9po0QVP6AC/oJlyrf915I3fP9C2Eqhx0HgHd9S2Cq8lMOAaHITzEEhCY/pRAQqvwUQkDo8odw44X1v/XqfRkSEYVwhuTzMkSGGgIWFs4ecCsX3HdNyJBpck7AUI65MYag8j2GoPI9hqDyPYag8j2GoPI9hqDy/X5O8Ld0Q1EURVEURVEURcLjMg7CLgCvIYCRAAAAAElFTkSuQmCC"
}));

var SvgTrust = function SvgTrust(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrust, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Trust.db0c5c27.svg";
export { ForwardRef as ReactComponent };